export default __webpack_public_path__ + "static/media/hht2_Intonation_06.5213cc33.png";